function getURLParameter(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1]) || null;
}

var metaWidth = getURLParameter('meta_width');
var metaHeight = getURLParameter('meta_height');
if (metaWidth && metaHeight) {
  var viewPortTag = document.createElement('meta');
  viewPortTag.name = 'viewport';
  viewPortTag.content = 'width=' + metaWidth + ', height=' + metaHeight;
  document.getElementsByTagName('head')[0].appendChild(viewPortTag);
}
